<template>
    <div class="home">
        <Nav/>
        <div class="banner-img">
            <img src="../assets/09.png"/>
        </div>
        <div class="main">
            <div class="pro-info">
                <div>
                    <h3>产品描述</h3>
                    <div class="mt25">福田运费贷是为福田汽车融资租赁的优质车主提供的信用贷款</div>
                </div>
                <div>
                    <h3>申贷条件</h3>
                    <div class="mt25">整车在福田金融做融资租赁的客户，年龄18-60周岁，客户有3个月及以上的还款记录且无逾期</div>
                </div>
                <div>
                    <h3>申贷流程</h3>
                    <div class="mt25"> ① 登录福田APP申请贷款</div>

                    <div> ② 风控审核通过贷款</div>

                    <div>③ 用户确认提交贷款金额与期限</div>

                    <div>④ 按合同约定以转账方式直接划入借款人的交易对象或发放给借款人</div>

                    <div>⑤ 正常还款</div>
                </div>
                <div>
                    <h3>所需材料</h3>
                    <div class="mt25">身份证正反面、车辆登记证、挂靠协议、银行卡</div>
                </div>
                <div>
                    <h3>贷款费用</h3>
                    <div class="mt25">年化11.5%</div>
                </div>
                <div>
                    <h3>还款和计息方式</h3>
                    <div class="mt25">先息后本，等额本息</div>
                </div>
                <div>
                    <h3>逾期处理方式</h3>
                    <div class="mt25">逾期罚息：每日收取贷款余额的0.06%罚息</div>
                </div>
                <div>
                    <h3>业务投诉电话</h3>
                    <div class="mt25">4008-830-822</div>
                </div>
            </div>
            <Foot class="mt100"/>
        </div>
    </div>
</template>

<script>
import Nav from './Nav';
import Foot from './Foot';

export default {
  name: 'Home',
  components: { Nav, Foot },
  props: {},
  methods: {
    effectiveLoanEvent() {
      this.$router.push({ path: `/permission/index?${+new Date()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .home {
        .banner-img {
            img {
                width: 100%;
            }
        }
        .main {
            height: 729px;
            padding-bottom: 100px;
            .pro-info {
                position: relative;
                margin-left: 25%;
                .black-bl {
                    position: absolute;
                    top: -17px;
                    color: rgba(51, 47, 43, 1);
                    font-weight: 500;
                    font-size: 26px;
                }
                div {
                    font-size: 13px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(142, 142, 142, 1);
                    line-height: 26px;
                }
                .mt25 {
                    margin-top: 25px;
                }
                h3 {
                    padding-top: 70px;
                    font-size: 20px;
                    color: rgba(51, 47, 43, 1);
                }
                .mt40 {
                    margin-top: 40px;
                }
                .ml60 {
                    margin-left: 3.125%;
                }
            }
        }

    }

</style>
